import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './style/navbar.css';
import logo from './assets/logo.png'; // Ensure you have a logo image in the assets folder

const Navbar = ({ animationType }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
    const [visible, setVisible] = useState(true);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            const visible = prevScrollPos > currentScrollPos;
            setPrevScrollPos(currentScrollPos);
            setVisible(visible);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [prevScrollPos, visible]);

    return (
        <nav className={`navbar ${visible ? 'visible' : 'hidden'}`}>
            <div className="navbar-logo">
                <Link to="/" onClick={closeMenu}>
                    <img src={logo} alt="Logo" />
                </Link>
            </div>
            <div className={`navbar-links ${animationType} ${isOpen ? 'active' : ''}`}>
                <ul>
                    <li><Link to="/" onClick={closeMenu}>Home</Link></li>
                    <li><Link to="/Product" onClick={closeMenu}>Product</Link></li>
                    <li><Link to="/About" onClick={closeMenu}>About</Link></li>
                </ul>
            </div>
            <div className="hamburger" onClick={toggleMenu}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>
        </nav>
    );
}

export default Navbar;
